// extracted by mini-css-extract-plugin
export default {"container":"HeroContent_container__2glci"};